module.exports = __webpack_public_path__ + "img/car_clio_symbol.39893770.jpg";